import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_Cft = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_Cft' className='file-pdf-document'>
            <div className='file-template'>





                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Consumer Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Medical Record Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtConsumerName" name="txtConsumerName" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtMedicalRecordNumber" name="txtMedicalRecordNumber" className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Medicaid ID:</span></td>
                        <td className='w-250'><span className='eleHeader'>Meeting Facilitator:</span></td>
                        <td className='w-250'><span className='eleHeader'>Meeting Location:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtMedicaidId" name="txtMedicaidId" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtMeetingFacilitator" name="txtMeetingFacilitator" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtMeetingLocation" name="txtMeetingLocation" className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Date:</span></td>
                        <td className='w-250'><span className='eleHeader'>Time:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date of Birth:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="date" id="txtDate" name="txtDate" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="time" id="txtTime" name="txtTime" className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id="txtDateBirth" name="txtDateBirth" className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center>
                        <h3>ATTENDEES</h3>
                    </center>
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-250'>PRINTED NAME:</td>
                        <td className='small w-250'>RELATIONSHIP:</td>
                        <td className='small w-250'>SIGNATURE:</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Child's Strengths (improved behavior since the last Child Family Team Meeting):</span>
                    <textarea id="txtChildStrengths" name="txtChildStrengths" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <b>WHAT ARE THE GOALS THAT THE CONSUMER IS CURRENTLY WORKING ON?</b> LIST GOALS IN ORDER OF PRIORITY
                </p>


                <table>
                    <tr>
                        <td className='w-20'>#</td>
                        <td className='w-250'><span className='eleHeader'>SHORT TERM GOAL</span></td>
                        <td className='w-250'><span className='eleHeader'>ASSESSMENT OF PROGRESS</span></td>
                        <td className='w-230'><span className='eleHeader'>REVISION</span></td>
                    </tr>
                    <tr>
                        <td className='w-20'>1 </td>
                        <td className='w-250'>
                            <input type="text" id="txtShortGoal_1" name="txtShortGoal_1" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtProgress_1" name="txtProgress_1" className='add-only' /></td>
                        <td className='w-230'> <input type="text" id="txtRevision_1" name="txtRevision_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>2 </td>
                        <td className='w-250'>
                            <input type="text" id="txtShortGoal_2" name="txtShortGoal_2" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtProgress_2" name="txtProgress_2" className='add-only' /></td>
                        <td className='w-230'> <input type="text" id="txtRevision_2" name="txtRevision_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>3 </td>
                        <td className='w-250'>
                            <input type="text" id="txtShortGoal_3" name="txtShortGoal_3" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtProgress_3" name="txtProgress_3" className='add-only' /></td>
                        <td className='w-230'> <input type="text" id="txtRevision_3" name="txtRevision_3" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>4</td>
                        <td className='w-250'>
                            <input type="text" id="txtShortGoal_4" name="txtShortGoal_4" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtProgress_4" name="txtProgress_4" className='add-only' /></td>
                        <td className='w-230'> <input type="text" id="txtRevision_4" name="txtRevision_4" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>5 </td>
                        <td className='w-250'>
                            <input type="text" id="txtShortGoal_5" name="txtShortGoal_5" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtProgress_5" name="txtProgress_5" className='add-only' /></td>
                        <td className='w-230'> <input type="text" id="txtRevision_5" name="txtRevision_5" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-20'>6</td>
                        <td className='w-250'>
                            <input type="text" id="txtShortGoal_6" name="txtShortGoal_6" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtProgress_6" name="txtProgress_6" className='add-only' /></td>
                        <td className='w-230'> <input type="text" id="txtRevision_6" name="txtRevision_6" className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>SUMMARY OF MEETING:</span>
                    <textarea id="txtSummaryMeeting" name="txtSummaryMeeting" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>PLAN FOR FOLLOW-UP:</span>
                    <textarea id="txtPlanFollowUp" name="txtPlanFollowUp" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>YOUTH'S LEVEL OF PARTICIPATION AND INPUT:</span>


                    <input type="radio" id="rbYouthLevelParticipation_1" name="rbYouthLevelParticipation" className='add-only' value="1" /> Poor &nbsp;
                    <input type="radio" id="rbYouthLevelParticipation_2" name="rbYouthLevelParticipation" className='add-only' value="2" /> Fair &nbsp;
                    <input type="radio" id="rbYouthLevelParticipation_3" name="rbYouthLevelParticipation" className='add-only' value="3" /> Good &nbsp;
                    <input type="radio" id="rbYouthLevelParticipation_4" name="rbYouthLevelParticipation" className='add-only' value="4" /> Very Good &nbsp;
                    <input type="radio" id="rbYouthLevelParticipation_5" name="rbYouthLevelParticipation" className='add-only' value="5" /> Excellent
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Next Meeting Date:</span></td>
                        <td className='w-250'><span className='eleHeader'>Location:</span></td>
                        <td className='w-250'><span className='eleHeader'>Time:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id="txtNextMeetingDate" name="txtNextMeetingDate" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="text" id="txtLocation" name="txtLocation" className='add-only' /></td>
                        <td className='w-250'>
                            <input type="time" id="txtMeetingTime" name="txtMeetingTime" className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Recorder's Name:</td>
                        <td className='small w-250'>Recorder's Signature:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>








            </div>
        </form>

    )
}  
